import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

function Dashboard() {
  const navigate = useNavigate();
  const [hasSession, setHasSession] = useState(false);
  const [sessionInfo, setSessionInfo] = useState(null);

  useEffect(() => {
    // Verificar si existe una sesión de análisis
    const storedSession = sessionStorage.getItem('analysisSession');
    if (!storedSession) {
      setHasSession(false);
      setSessionInfo(null);
      return;
    }

    try {
      const parsed = JSON.parse(storedSession);
      setHasSession(true);
      setSessionInfo(parsed);
    } catch (error) {
      setHasSession(false);
      setSessionInfo(null);
    }
  }, []);

  const formatFilterLabel = (key) =>
    key
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (letter) => letter.toUpperCase());

  const activeFilters = Object.entries(sessionInfo?.filters || {}).filter(([_, value]) => {
    if (value === undefined || value === null) return false;
    return String(value).trim() !== '';
  });

  if (!hasSession) {
    return (
      <div className="dashboard-container">
        <div className="dashboard-error">
          <h2 style={{ color: '#1391DA', marginBottom: '1rem', fontFamily: 'var(--font-title)', textTransform: 'uppercase', fontWeight: 'bold' }}>Análisis no iniciado</h2>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.6', maxWidth: '600px', margin: '0 auto 2rem' }}>
            Primero debe iniciar un análisis para poder cargar el dashboard. Seleccione los filtros que desee y de clic en "Iniciar Análisis".
          </p>
          <button 
            className="btn btn-primary" 
            onClick={() => navigate('/licitaciones/buscar')}
            style={{ padding: '0.75rem 2rem', fontSize: '1rem' }}
          >
            Ir a Licitaciones
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-welcome">
        <h2 className="dashboard-welcome-title">¡Listo! Ya puedes analizar los datos solicitados</h2>
      </div>
      <div className="dashboard-header">
        <h1 className="dashboard-title" style={{ fontFamily: 'var(--font-title)', textTransform: 'uppercase', fontWeight: 'bold' }}>Dashboard de Análisis</h1>
        <button
          className="btn btn-secondary"
          onClick={() => navigate('/licitaciones/buscar')}
        >
          ← Volver a licitaciones
        </button>
      </div>

      <div className="dashboard-content">
        {/* Sección de análisis */}
        <div className="dashboard-card metrics-placeholder">
          <h2>Análisis de Datos</h2>
          <p className="placeholder-text">
            Visualice el reporte del análisis actual
          </p>
          <div className="analysis-summary-layout">
            <div className="analysis-summary-left">
              <button
                className="analysis-button analysis-button-wide"
                onClick={() => navigate('/dashboard/reporte')}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" className="analysis-icon" viewBox="0 0 16 16">
                  <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                  <path d="M4 12h8a.5.5 0 0 0 0-1H4a.5.5 0 0 0 0 1m0-4h8a.5.5 0 0 0 0-1H4a.5.5 0 0 0 0 1m0-4h8a.5.5 0 0 0 0-1H4a.5.5 0 0 0 0 1"/>
                </svg>
                <div className="analysis-title">Ver reporte</div>
              </button>
            </div>
            <div className="analysis-summary-right">
              <div className="analysis-summary-block">
                <span className="analysis-summary-label">Registros analizados</span>
                <strong className="analysis-summary-value">
                  {sessionInfo?.recordCount?.toLocaleString?.('es-CO') || sessionInfo?.recordCount || 0}
                </strong>
              </div>

              <div className="analysis-summary-block">
                <span className="analysis-summary-label">Filtros utilizados</span>
                {activeFilters.length > 0 ? (
                  <ul className="analysis-filters-list">
                    {activeFilters.map(([key, value]) => (
                      <li key={key}>
                        <span className="analysis-filter-key">{formatFilterLabel(key)}:</span> {String(value)}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="analysis-summary-empty">Sin filtros específicos. El análisis incluye todos los registros consultados.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
